const WORDS = ["ACA / Obamacare", "Private Health", "Dental", "Vision", "Hearing", "Final Expense", "Indexed Universal Life", "Whole Life", "College Savings", "Retirement"];

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="marquee-wrap bg-[#0B281E] border-y border-white/10 py-7 overflow-hidden">
    <div className="marquee-track flex w-max whitespace-nowrap">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`font-serif-d text-4xl md:text-6xl px-8 ${i % 2 ? "italic text-[#E5A855]" : "text-[#FAF8F5]"}`}>{w}</span>
              <span className="w-2.5 h-2.5 rotate-45 bg-[#C88A35]" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
